/**
 * Canonical JSON block representation for location data across Memories and Media.
 */
export interface ILocation {
  /** Latitude coordinate in decimal degrees */
  latitude?: number;
  /** Longitude coordinate in decimal degrees */
  longitude?: number;
  /** Human-readable location text, address, or place name */
  text?: string;
  /** Whether this location is an approximation rather than precise coordinates */
  isApproximate?: boolean;
}
